import { render, staticRenderFns } from "./exam-list.vue?vue&type=template&id=07d967e4&"
import script from "./exam-list.vue?vue&type=script&lang=ts&"
export * from "./exam-list.vue?vue&type=script&lang=ts&"
import style0 from "./exam-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports